var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import "../AttributeMap";
import { defaults, heapDefaults, monospace, mutable, outlineColor } from "../../style";
import { deepAwaitMixin } from "../../mixins/DeepAwaitMixin";
let InstanceComponent = class InstanceComponent extends deepAwaitMixin(LitElement) {
    get instanceAttributes() {
        const headerLength = this.isPPrint ? 3 : 2;
        return this.el.slice(headerLength);
    }
    get name() {
        return this.el[1];
    }
    get isPPrint() {
        return this.el[0] === "INSTANCE_PPRINT";
    }
    render() {
        return html `
            <label>${this.name} instance</label>
            <table>
                ${this.isPPrint ? html `<tr><td colspan="2" class="pprint">${this.el[2]}</td></tr>` : html ``}
                ${ // Hacky fix:  webcomponents are not allowed inside table, but templates are
        html `<tc-attribute-map .attributeEls=${this.instanceAttributes}></tc-attribute-map>`}
            </table>
        `;
    }
};
InstanceComponent.styles = [defaults, heapDefaults, mutable, css `
      td {
        border-bottom: 1px solid ${outlineColor};
      }
        .pprint {
            font-family: ${monospace};
            white-space: pre;
        }
    `];
__decorate([
    property({ type: Array })
], InstanceComponent.prototype, "el", void 0);
InstanceComponent = __decorate([
    customElement('tc-instance')
], InstanceComponent);
export { InstanceComponent };
//# sourceMappingURL=InstanceComponent.js.map